import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path stroke=\"currentColor\" d=\"M19.25 10.5L10.3334 6.93336C9.76396 6.70558 9.12553 7.03937 8.98762 7.63698L6.25 19.5\"></path><path stroke=\"currentColor\" d=\"M18 8.19922L9.0834 4.63258C8.51396 4.4048 7.87553 4.73859 7.73762 5.3362L5 17.1992\"></path><circle stroke=\"currentColor\" fill=\"currentColor\" cx=\"8.5\" cy=\"5.5\" r=\"2.5\"></circle><circle stroke=\"currentColor\" fill=\"currentColor\" cx=\"18.5\" cy=\"9.5\" r=\"2.5\"></circle><circle stroke=\"currentColor\" fill=\"currentColor\" cx=\"5.5\" cy=\"18.5\" r=\"2.5\"></circle>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }